import React from 'react';

interface ComingSoonPanelProps {
  title: string;
  description: string;
}

const ComingSoonPanel: React.FC<ComingSoonPanelProps> = ({ title, description }) => {
  return (
    <section className="panel-surface coming-soon-panel">
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="coming-soon-note">This module is scaffolded and ready for API integration.</div>
    </section>
  );
};

export default ComingSoonPanel;
